import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from '../../service';
import { UsersService } from '../../service/user.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  toasterTitle:any;
  ok_btn:any;
  contentMsg: any;
  code: any;
  constructor(
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogref: MatDialogRef<ToasterComponent>,
    public snackbar: MatSnackBar,
    private cdRef : ChangeDetectorRef,
    public userService: UsersService,
    public utility: UtilityService
    ) { }

  ngOnInit() { 
    if(this.data.mode == 'Success') {
     this.userService.getErrorMessage('AW01GENMSG_010').then(res => { this.toasterTitle = res; })
    } else if(this.data.mode == 'Error'){
      this.userService.getErrorMessage('AW01GENMSG_022').then(res => { this.toasterTitle = res; })
    } else {
      this.userService.getErrorMessage('WW08OBICXX_004').then(res => { this.toasterTitle = res; })
    }
    this.userService.getErrorMessage('AW01GENMSG_011').then(res => { this.ok_btn = res; })
    if(this.data.msg){
      if(this.data.msg.includes("-")) {
        const myArray = this.data.msg.split("-");
        this.contentMsg = myArray[1];
        this.code = myArray[0]
      } else {
        this.contentMsg = this.data.msg
      }
    } 
  }

  confirmDelete() {
    this.utility.canShowPopUp='';
    this.dialogref.close(true)
  }
}
